module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page_wrap"
  }, [_c('el-pagination', {
    attrs: {
      "background": true,
      "current-page": _vm.pageInfo.currentPage,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pageInfo.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.pageInfo.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6355d90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagination.vue
// module id = MWQS
// module chunks = 6